import LoadingOverlay, { ContainedLoadingOverlay } from './LoadingOverlay';

export default LoadingOverlay;
export { ContainedLoadingOverlay };
